











import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class PatientAcquisitionExportationFrameTitle extends Vue {
  @Prop({ required: true }) private type!: string;

  get title() {
    switch (this.type) {
      case 'podosmart':
        return this.$tc('commons.sentences.results-walk-analysis');
      case 'podorun':
        return this.$tc('commons.sentences.results-run-analysis');
      default:
        return 'N/A';
    }
  }
}
